import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import LoginPage from "../pages/Login/LoginPage";
import RegisterPage from "../pages/Register/RegisterPage";
import HomePage from "../pages/Home/HomePage"; // Assuming you have a HomePage component
import PrivateRoute from "./PrivateRoute"; // We will create this component

import ForgotPassword from "../pages/ForgotPassword/ForgotPassword";
import ResetPassword from "../pages/ResetPassword/ResetPassword";

import BypassLogin from "../pages/Login/BypassLogin";

import { useAuth } from "../context/AuthContext";
import CreateOrganizer from "../pages/Venue/CreateOrganizer";
import AddSubUser from "../pages/Venue/SubUsers";
import OrganizerDashboard from "../pages/Organizer/OrganizerHome";
import OrganizerProfileEdit from "../pages/Organizer/EditOrganizer";
import RunReport from "../pages/Venue/RunReport";
import ContactList from "../pages/Venue/Contacts";
import EventSchedule from "../pages/Venue/EventSchedule";
import CreateCalEvent from "../pages/Venue/CreateNewEvent";
import CreateEventForVenue from "../pages/Venue/CreateEventForVenue";
import UpdateVenue from "../pages/Venue/UpdateVenue/UpdateVenue";
import VenueEvents from "../pages/Venue/VenueEvents";

const AppRoutes = () => {
  const isAuth = !!localStorage.getItem("token");
  const { user } = useAuth();
  console.log("user from context", user);
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={<Navigate to={isAuth ? "/home" : "/login"} />}
        />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/bypass-login" element={<BypassLogin />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        <Route
          path="/home"
          element={
            <PrivateRoute>
              <HomePage />
            </PrivateRoute>
          }
        />
        <Route
          path="/update-venue"
          element={
            <PrivateRoute>
              <UpdateVenue />
            </PrivateRoute>
          }
        />
        <Route
          path="/create-organizer"
          element={
            <PrivateRoute>
              <CreateOrganizer />
            </PrivateRoute>
          }
        />
        <Route
          path="/organizer-profile-edit/:organizerId"
          element={
            <PrivateRoute>
              <OrganizerProfileEdit />
            </PrivateRoute>
          }
        />
        <Route
          path="/venue-events"
          element={
            <PrivateRoute>
              <VenueEvents />
            </PrivateRoute>
          }
        />
        <Route
          path="/events-schedule"
          element={
            <PrivateRoute>
              <EventSchedule />
            </PrivateRoute>
          }
        />
        <Route
          path="/create-new-event"
          element={
            <PrivateRoute>
              <CreateCalEvent />
            </PrivateRoute>
          }
        />  
        <Route
          path="/create-venue-event"
          element={
            <PrivateRoute>
              <CreateEventForVenue />
            </PrivateRoute>
          }
        />
        <Route
          path="/edit-venue-event"
          element={
            <PrivateRoute>
              <CreateEventForVenue />
            </PrivateRoute>
          }
        />
        <Route
          path="/add-new-sub-user"
          element={
            <PrivateRoute>
              <AddSubUser />
            </PrivateRoute>
          }
        />
        <Route
          path="/contact-lists"
          element={
            <PrivateRoute>
              <ContactList />
            </PrivateRoute>
          }
        />
        <Route
          path="/organizer/:organizerId"
          element={
            <PrivateRoute>
              <OrganizerDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/organizer/:organizerId/contact-lists"
          element={
            <PrivateRoute>
              <ContactList />
            </PrivateRoute>
          }
        />
        <Route
          path="/organizer/:organizerId/add-new-sub-user"
          element={
            <PrivateRoute>
              <AddSubUser />
            </PrivateRoute>
          }
        />
        <Route
          path="/organizer/:organizerId/reports/run-report"
          element={
            <PrivateRoute>
              <RunReport />
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
